import React from 'react';
import action from '../../assets/sai-action.png';

const Action = () => {


  return (
    <div>
        <img src={action} alt="Slider-Image"/>

    </div>
  );

};
export default Action;
